export function getUrl() {
    const currentUrl = new URL(window.location.href);
    const protocol = currentUrl.protocol === 'https:' ? 'wss' : 'ws';
    const domain = currentUrl.hostname +  (currentUrl.port ? ':' + currentUrl.port : '');
    const wsUrl = `${protocol}://${domain}/api/websocket/auctionWebSocket`;
    return wsUrl;
}